import React, { useState } from 'react';
import {
  Alert, Box, Typography, Button, Collapse,
  List, ListItem, ListItemText, LinearProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function DuplicateWarning({ duplicates, onDismiss, onViewDoc }) {
  const [expanded, setExpanded] = useState(false);

  if (!duplicates || duplicates.length === 0) return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onDismiss}>
          Upload Anyway
        </Button>
      }
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle2">
            ⚠️ Similar documents found ({duplicates.length})
          </Typography>
          <Button
            size="small"
            onClick={() => setExpanded((v) => !v)}
            endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            sx={{ ml: 1 }}
          >
            {expanded ? 'Hide' : 'Show'}
          </Button>
        </Box>
        <Collapse in={expanded}>
          <List dense sx={{ mt: 1 }}>
            {duplicates.map((dup, idx) => (
              <ListItem
                key={dup._id || idx}
                sx={{ px: 0, flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <ListItemText
                  primary={dup.title || dup.filename || 'Untitled'}
                  secondary={
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                      <Typography variant="caption" component="span">
                        {dup.vault ? `Vault: ${dup.vault} · ` : ''}
                        Similarity: {Math.round((dup.score || dup.similarity || 0) * 100)}%
                      </Typography>
                      <LinearProgress
                        variant="determinate"
                        value={Math.round((dup.score || dup.similarity || 0) * 100)}
                        sx={{ width: 60, height: 4, borderRadius: 2 }}
                        color="warning"
                      />
                    </Box>
                  }
                />
                {onViewDoc && (
                  <Button size="small" onClick={() => onViewDoc(dup)} sx={{ mt: 0.5 }}>
                    View Document
                  </Button>
                )}
              </ListItem>
            ))}
          </List>
        </Collapse>
      </Box>
    </Alert>
  );
}
